import type { RouteObject } from 'react-router-dom';

import MainLayout from '@/app/layouts/MainLayout';
import { AuthGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';

/**
 * 구독 관련 라우트(/subscription). 현재는 재활성화만.
 * AuthGuard(로그인) → 일시정지 구독 복구 화면.
 */
export const subscriptionRoutes: RouteObject = {
  path: 'subscription',
  Component: MainLayout,
  children: [
    {
      element: <AuthGuard />,
      children: [
        {
          path: 'reactivate/:id',
          ...lazyRoute(() => import('@/pages/subscription/ReactivatePage')),
        },
      ],
    },
  ],
};
